/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { arrayOf, entity, enumeration, enumMap, identity, subentity } from '@gh/core-data';

import {
  ContactCustomerListItemDto,
  ContactSupplierListItemDto,
  ContactVendorListItemDto,
} from '../';
import { ContactCustomerType } from '../model/contact-details-customer.dto';
import { ContactDeliveryMethod } from '../model/contact-details-shared.dto';
import {
  ContactListFilterDto,
  ContactListInitDto,
  ContactListInitTypeDto,
  ContactListItemDto,
} from '../model/contact-list-item.dto';
import { ContactType } from '../model/contact-type.enum';

export const ContactListItemMapper = entity<ContactListItemDto>({
  types: enumMap(ContactType, identity()),
});

export const ContactListInitMapper = entity<ContactListInitDto>({
  options: arrayOf(subentity<ContactListInitTypeDto>({
    type: enumeration(ContactType),
  })),
});

export const ContactListFilterMapper = entity<ContactListFilterDto>({
  types: arrayOf(enumeration(ContactType)),
});

export const ContactCustomerListItemMapper = entity<ContactCustomerListItemDto>({
  typeOfCustomer: enumeration(ContactCustomerType),
});

export const ContactSupplierListItemMapper = entity<ContactSupplierListItemDto>({
  orderBy: enumeration(ContactDeliveryMethod),
  scheduleBy: enumeration(ContactDeliveryMethod),
});

export const ContactVendorListItemMapper = entity<ContactVendorListItemDto>({
  deliveryMethod: enumeration(ContactDeliveryMethod),
});
